
import Vue from "vue";
import Component from "vue-class-component";
import {namespace} from "vuex-class";
import {Prop} from "vue-property-decorator";
import {ICell, IRestrictions} from "@/model/Locker/lockerInterfaces";
import {IShortServiceProvider} from "@/model/shortInterfaces";
import ServiceProviderChip from "@/components/shared/chips/ServiceProviderChip.vue";

const serviceProviderModule = namespace("serviceProviderModule");

@Component({
  name: 'RestrictSPInCellTooltip',
  components: {
    ServiceProviderChip
  },
})
export default class RestrictSPInCellTooltip extends Vue {
  @serviceProviderModule.Getter('serviceProvidersByIds')
  private serviceProvidersByIds!: (ids: number[]) => IShortServiceProvider[]

  @Prop({default: () => {}})
  private cell!: ICell;

  protected restrictedSP(restrictions: IRestrictions[]): IShortServiceProvider[] {
    const ids: number[] = this.cell.restrictions.map((res: IRestrictions) => res.service_provider_id);
    return this.serviceProvidersByIds(ids);
  }

}
